import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=aad061a4&"
import script from "./Changepassword.vue?vue&type=script&lang=js&"
export * from "./Changepassword.vue?vue&type=script&lang=js&"
import style0 from "./Changepassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports